// pc接力支付引导
var PaymentGuideManager = require("activity/IosPaymentGuide/PaymentGuideManager")
var PaymentGuideRedirector = xClass("PaymentGuideRedirector", BaseRedirector)
PaymentGuideRedirector.prototype.getName = function () {
    var self = this
    return "handoffPaymentGuide"
}
PaymentGuideRedirector.prototype.hasHighPriorityAction = function () {
    return false
}
PaymentGuideRedirector.prototype.redirect = function () {
    var self = this
    // console.log("redirect times")
    // return false

    var curScene = cc.Director.getInstance().getRunningScene()
    if (!curScene || curScene.name != "HomeScene"){
        return false
    }else{
        return new Promise((resolve, reject)=> {
            DCAssist.dc4User101("ios_payment","jump_success",{session: PaymentGuideManager.getInstance().createDCSession()})
            //来自pc接力按钮
            PaymentGuideManager.getInstance().setFromHandoff(true);
            if(!MetaManager.isSupportCash()){
                resolve()
            }else{
                // require("clover/panel/MarketPanel").show(1, '' , '',  ()=> {
                //     resolve()
                // })
                MarketManager.getInstance().showMarketPanel(null, (panel)=>{
                    panel.on(BasePanelEvent.Close, ()=> resolve())
                })
            }

        })
    }
}
module.exports = PaymentGuideRedirector
